export default "__VITE_ASSET__SsMBtgX5__"